export const materialKeyMap = {
  mainPosts: "mainPost",
  linePosts: "linePost",
  mainPostCaps: "mainPostCap",
  linePostCaps: "linePostCap",
  concreteBags: "concrete",
  fenceTies: "fenceTies",
  mesh: "mesh",
  tensionBands: "tensionBand",
  tensionBars: "tensionBar",
  topRailAssemblys: "topRailEndConnector",
  topRails: "topRail",
  topRailSleeves: "topRailSleeve",
  tensionWire: "tensionWire",
  centerMainPostBands: "centerMainPostBand",
  nutsAndBolts: "nutAndBolt",
};

export const materialDisplayNames = {
  mainPosts: "Main Posts",
  linePosts: "Line Posts",
  mainPostCaps: "Main Post Caps",
  linePostCaps: "Line Post Caps",
  concreteBags: "Concrete Bags",
  fenceTies: "Fence Ties",
  mesh: "Mesh",
  tensionBands: "Tension Bands",
  tensionBars: "Tension Bars",
  topRailAssemblys: "Top Rail End Connectors",
  topRails: "Top Rails",
  topRailSleeves: "Top Rail Sleeves",
  tensionWire: "Tension Wire",
  centerMainPostBands: "Center Main Post Bands",
  nutsAndBolts: "Nuts And Bolts",
};
